module.exports = __webpack_public_path__ + "static/mid1-d5b71ddb9c1d20644d189c4183d668df.png";